import { Inject, Injectable, PLATFORM_ID  } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class TranslateService {

    langKey: string = "culture";
    language: string = "it-IT";
    data: any = {};

    constructor(
        private http: HttpClient,
        @Inject(PLATFORM_ID) private platformId: any) { }

    use(lang: string): Promise<{}> {

        this.language = lang;

        if (isPlatformBrowser(this.platformId)) {
            sessionStorage.setItem(this.langKey, this.language);
        }

        return new Promise<{}>((resolve, reject) => {
            const langPath = `dist/assets/i18n/${lang || 'it-IT'}.json`;
            this.http.get<{}>(langPath).subscribe(
                translation => {
                    this.data = Object.assign({}, translation || {});
                    resolve(this.data);
                },
                error => {
                    this.data = {};
                    resolve(this.data);
                }
            );
        });
    }

    get(key: string): string {

        if (!this.data) {
            this.use(this.language).then(res => {
                return this.data[key] || key;
            });
        }
        else {
             return this.data[key] || key;
        }

    }

    setDefaultLanguage() {
        if (isPlatformBrowser(this.platformId)) {
            var lang = sessionStorage.getItem(this.langKey);
            if (lang) {
                this.use(lang);
            }
            else {
                this.setBrowserLanguage();
            }
        }
        else {
            this.setBrowserLanguage();
        }
    }

    setBrowserLanguage() {
        var browser_lang = navigator.language;
        if (browser_lang === "it-IT" || browser_lang === "it") this.use('it-IT');
        else this.use('en-US');
    }

    getLanguage(): string {
        return this.language;
    }

}


// WEBPACK FOOTER //
// ./ClientApp/app/_services/translate.service.ts